import { AbstractControl } from "@angular/forms";
import { ValidatorFn } from "@angular/forms";

// The built in angular email validator does not match the PHP validator.
// Specifically, angular does not require a domain on the email address.
// Which is technically valid, but totally impractical.
export class EmailValidator {
    static email(control: AbstractControl) {
        const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;

        if (
            control.value !== "" &&
            (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))
        ) {
            return { email: true };
        }

        return null;
    }
}
